new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');
            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                var inputElement = document.getElementById("valorParaCopiar");
                if (inputElement) {
                    var newValueInput = inputElement.value.replace(/^\/\//, '');
                    inputElement.value = newValueInput

                    if (formButton) {
                        formButton.addEventListener("click", (e) => {
                            e.preventDefault();

                            inputElement.select();

                            document.execCommand("copy");

                            window.getSelection().removeAllRanges();

                            alert("Valor copiado: " + newValueInput);
                        });
                    }
                }
            }
        });

        waitForElementToExist('.buy-size-guide').then(element => {
            if (window.outerWidth < 992) {
                const container = document.querySelector('.buy-size-guide');
                const items = Array.from(container.children);

                console.log('Container encontrado:', container);
                console.log('Items originais:', items.length);
                console.log('Largura da tela:', window.innerWidth);

                if (items.length > 0) {
                    const half = Math.ceil(items.length / 2);

                    // Cria duas divs
                    const firstDiv = document.createElement('div');
                    const secondDiv = document.createElement('div');

                    // Adiciona classes para estilização
                    firstDiv.className = 'buy-size-guide-row buy-size-guide-row-1';
                    secondDiv.className = 'buy-size-guide-row buy-size-guide-row-2';

                    // Distribui os itens nas duas divs
                    for (let i = 0; i < half; i++) {
                        firstDiv.appendChild(items[i]);
                    }

                    for (let i = half; i < items.length; i++) {
                        secondDiv.appendChild(items[i]);
                    }

                    // Limpa o container e adiciona as duas divs
                    container.innerHTML = "";
                    container.appendChild(firstDiv);
                    container.appendChild(secondDiv);

                    console.log('Items reorganizados:', items.length, 'items');
                    console.log('Primeira div:', half, 'items');
                    console.log('Segunda div:', items.length - half, 'items');
                }
            } else {
                console.log('Tela maior que 992px, reorganização não aplicada');
            }
        });

        const btnLeiaMais = document.getElementById('btn-leia-mais');
        const maisTexto = document.getElementById('mais-texto');

        btnLeiaMais.addEventListener('click', () => {
            // Verifica se a classe 'escondido' está aplicada
            if (maisTexto.classList.contains('escondido')) {
                maisTexto.classList.remove('escondido');
                btnLeiaMais.textContent = 'Ver menos';
            } else {
                maisTexto.classList.add('escondido');
                btnLeiaMais.textContent = 'Ver mais';
            }
        });
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.first-vitrine').then(element => {
        $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3, #carrousel-product-list4, #carrousel-product-list5').slick({
            arrows: true,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');

                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list',
                        '#carrousel-product-list2',
                        '#carrousel-product-list3',
                        '#carrousel-product-list4',
                        '#carrousel-product-list5'
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('refresh')
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3, #carrousel-product-list4, #carrousel-product-list5').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.rotation-banner').then(element => {
        $('#carrousel-banner-photos, #carrousel-banner-photos2, #carrousel-banner-photos3, #carrousel-banner-photos4, #carrousel-banner-photos5').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                },
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.banner-select .banner-select-name');
            let initVitrine = element.querySelectorAll('.banner-photos .banner-photos-item');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');

                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    // Refresh slick carousels
                    const carouselIds = [
                        '#carrousel-banner-photos',
                        '#carrousel-banner-photos2',
                        '#carrousel-banner-photos3',
                        '#carrousel-banner-photos4',
                        '#carrousel-banner-photos5'
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('refresh')
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }
    });

});